import React from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAuth } from '../contexts/AuthContext';
import { FeatureEnum } from '../components/FeatureGate';
import { Link } from 'react-router-dom';

export const RequireFeature = ({
  children,
  feature
}: {
  children: JSX.Element;
  feature: FeatureEnum;
}) => {
  const { loading, features } = useAuth();

  if (loading) return <LoadingSpinner />;

  if (!features.includes(feature)) {
    return (
      <div>
        <h2>Access Denied</h2>
        <p>
          You do not have access to this feature. Please{' '}
          <Link to="/account/subscription">upgrade your account</Link> to gain
          access.
        </p>
      </div>
    );
  }

  return children;
};
